export default __webpack_public_path__ + "locales/ro/DeleteProfileEverDialog.json?hash=0116791d7fa278d91cbbf5fc1cace670";